import React, { useState } from "react";

const faqData = [
  {
    question: "What is meant by online check-in for airlines?",
    answer:
      "The process of confirming your tickets online is called online check-in. This confirms your presence on the flight. It helps avoid long queues at the airport. Online check-in usually opens 24–48 hours before the flight and closes 1–2 hours prior. You can check the airline's policy on their website.",
  },
  {
    question: "How to place a request for an in-flight meal?",
    answer:
      "Low-cost carriers usually charge for meals. You can request a meal while booking, at least 24 hours before departure. Agents with BookTrip4Me may request on your behalf, but it's not guaranteed as it's up to the airline’s discretion.",
  },
  {
    question:
      "Why did the fare increase after I placed my booking and received confirmation?",
    answer:
      "The confirmation means your request was received, not finalized. Airfares are dynamic and change frequently. When agents book your ticket, the earlier fare may be unavailable, and the next available seat may be higher-priced.",
  },
  {
    question: "How to select special seats when onboard?",
    answer:
      "Inform us in advance if you prefer a window or aisle seat. Some airlines allow seat selection during online check-in. We can request a seat, but it's not guaranteed and may require a fee.",
  },
  {
    question: "How to know that I have a confirmed booking?",
    answer:
      "You'll receive a confirmation email once we get your request. This includes booking details and shows our agents are now searching flights for you.",
  },
  {
    question: "What is a holiday package on BookTrip4Me?",
    answer:
      "A holiday package is a combination of flight and hotel bookings that typically offers better pricing than booking separately. It's priced per person for double occupancy.",
  },
  {
    question:
      "What are the benefits of purchasing a holiday package with BookTrip4Me?",
    answer:
      "You save time and money. Packages include low airfares, Book Now Pay Later options, and discounted hotel rates. Travel dates are flexible with no fixed length of stay.",
  },
  {
    question:
      "How do I know if the holiday package I purchased is worth my money?",
    answer:
      "Travel in the off-season and midweek (Tuesday, Wednesday) for cheaper rates. Avoid weekends and holidays. Our agents will help you find the best value.",
  },
  {
    question:
      "When booking a holiday package, can I opt for a flight or hotel of my choice?",
    answer:
      "Yes. Packages are fully customizable. You can request specific flights or hotels, but fare differences and service fees may apply.",
  },
  {
    question:
      "Am I allowed to cancel part of my holiday package and retain the rest?",
    answer:
      "No. If you cancel part, the entire package is canceled. Individual cancellation policies apply.",
  },
  {
    question: "Will I receive a confirmation voucher for my hotel reservation?",
    answer:
      "Yes. You’ll receive an email with booking reference and hotel vouchers within 24–48 hours.",
  },
  {
    question:
      "Can additional guests be added to an already made hotel booking?",
    answer:
      "Yes, if availability allows. We’ll check with the hotel. A service fee and tariff difference apply.",
  },
  {
    question:
      "What if the hotel charges more than the confirmed booking amount?",
    answer:
      "Some hotels charge additional resort or government fees. Bring your reservation printout and ask the hotel to resolve extra charges.",
  },
  {
    question: "How to cancel my hotel booking?",
    answer:
      "To cancel your reservation, contact BookTrip4Me Customer Support at +1 888-711-2909. Our team will guide you through the cancellation process and inform you about any applicable fees.",
  },
  {
    question: "What if I face issues during hotel check-in?",
    answer:
      "Carry your confirmation email and voucher. If the hotel is overbooked and you have a confirmed booking, they must offer an alternative property. Contact BookTrip4Me support if this occurs.",
  },
  {
    question:
      "I want to reschedule my hotel booking dates. How can I do that?",
    answer:
      "Contact our support team at BookTrip4Me. Date or name changes are subject to hotel policies. A service fee may apply to process changes.",
  },
  {
    question: "How to get in touch with your travel consultants?",
    answer:
      "Call us anytime at +1 888-711-2909 or email us at support@BookTrip4Me.com. Our team responds within 24 hours.",
  },
];

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">

      {/* Page Title */}
      <h1 className="text-3xl md:text-4xl font-extrabold text-center text-green-700 mb-10 drop-shadow-sm">
        Frequently Asked Questions
      </h1>

      {/* FAQ List */}
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className="rounded-2xl bg-white shadow-md border border-green-200 overflow-hidden transition-all"
          >
            <button
              onClick={() => toggleFaq(index)}
              className="w-full flex justify-between items-center p-5 text-left bg-green-50 hover:bg-green-100 transition text-gray-900 font-semibold text-lg"
            >
              <span>{faq.question}</span>

              <span
                className={`text-green-600 text-2xl transform transition-transform ${
                  openIndex === index ? "rotate-45" : ""
                }`}
              >
                +
              </span>
            </button>

            <div
              className={`px-5 text-gray-700 overflow-hidden transition-all ${
                openIndex === index ? "max-h-[500px] py-4" : "max-h-0"
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqPage;
